import { useTranslate } from './hooks/useTranslate';

/**
 * @deprecated use translation hook instead
 */
const consumeTranslations = Component => (function InnerConsumeTranslations(props) {
    const translate = useTranslate();

    return (
        <Component
            {...props}
            translate={translate}
        />
    );
});

export default consumeTranslations;
